const logLevelTypes = {
    INFO: "INFO",
    TRACE: "TRACE",
    WARNING: "WARNING",
    DEBUG: "DEBUG",
    ERROR: "ERROR",
}

export default logLevelTypes;